import "@/sentry";
import ReactDOM from "react-dom/client";
import App from "@/App.tsx";
import "@/styles/styles.css";

ReactDOM.createRoot(document.getElementById("root")!).render(<App />);
